import { Routes, Route } from 'react-router-dom'
import GuestApplyStatus from './GuestApplyStatus'
import ChurchApplyBoard from './ChurchApplyBoard'

// 계정 없이 쓰는 지원 화면 — 메일 속 링크(토큰)로만 들어온다 (server routers/resume/applyRelay.js)
export default function ApplyRouter() {
  return (
    <Routes>
      <Route path="/status/:token" element={<GuestApplyStatus />} />
      <Route path="/church/:token" element={<ChurchApplyBoard />} />
    </Routes>
  )
}
